import React from 'react';

export default function Skeleton({ rows = 4 }) {
  return <div className="panel skeleton-list">{Array.from({ length: rows }, (_, index) => <div className="skeleton-row" key={index}><span /><div><b /><i /></div></div>)}</div>;
}